<template>
  <span class="inp_number_wrap">
    <InputBase v-bind="attrs" v-on="listeners" v-model="model" onlyNumber ref="element" @input="onInput" />
    <button type="button" class="number_decrease" @click="decrease()">
      <span class="txt_hidden">decrease</span>
    </button>
    <button type="button" class="number_increase" @click="increase()">
      <span class="txt_hidden">increase</span>
    </button>
  </span>
</template>

<script>
import InputBase from './InputBase.vue';
import numeral from 'numeral';

export default {
  components: {
    InputBase,
  },

  model: {
    prop: 'value',
    event: 'update',
  },

  props: {
    value: {
      type: Number,
      default: 0,
    },
    comma: Boolean,
    format: {
      type: String,
      default: '0',
    },
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER,
    },
    min: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      localValue: this.value,
    };
  },
  computed: {
    attrs() {
      return {
        ...this.$attrs,
        type: 'tel',
      };
    },
    listeners() {
      return {
        ...this.$listeners,
        update: () => {},
        keydown: this.onKeydown,
      };
    },

    model: {
      get() {
        if (typeof this.localValue === 'number') {
          return numeral(this.localValue).format(this.comma ? '0,0' : this.format);
        }
        return '';
      },
      set(value) {
        let newValue = numeral(value).value() || 0;
        if (newValue < this.min) newValue = this.min;
        if (newValue > this.max) newValue = this.max;
        this.localValue = newValue;
      },
    },
  },
  methods: {
    onKeydown(e) {
      if (/([0-9])/.test(e.key)) {
        if (String(this.localValue || '').length >= this.maxLength) e.preventDefault();
      }
    },
    focus() {
      this.$el.querySelectorAll('input,select,textarea')[0]?.focus();
    },
    decrease() {
      const newValue = (this.localValue || 0) - 1;
      if (newValue < this.min) {
        this.localValue = this.min;
        return;
      }
      this.localValue = newValue;
    },
    increase() {
      const newValue = (this.localValue || 0) + 1;
      if (newValue > this.max) {
        this.localValue = this.max;
        return;
      }
      this.localValue = newValue;
    },

    onInput(e) {
      const newValue = numeral(e.target.value).value() || 0;

      if (newValue < this.min) {
        e.target.value = numeral(this.min).format(this.comma ? '0,0' : this.format);
        return
      }
      if (newValue > this.max) {
        e.target.value = numeral(this.max).format(this.comma ? '0,0' : this.format);
        return
      }
      e.target.value = numeral(newValue).format(this.comma ? '0,0' : this.format);
    },
  },
  watch: {
    value() {
      this.localValue = this.value;
    },
    localValue() {
      this.$emit('update', this.localValue);
    },
  },
};
</script>
